/**
 * Capitalizes the first letter of a string and makes the rest lowercase.
 */
export function capitalize<S extends string>(text: S): Capitalize<S> {
  return text.length
    ? ((text[0].toUpperCase() + text.slice(1).toLowerCase()) as Capitalize<S>)
    : (text as Capitalize<S>);
}
